<template>
<div> 
  <b-container fluid>
  <b-row v-if="!item || !item.nimi">
        <b-col>
            <InfoCard></InfoCard>
        </b-col>
  </b-row>
  <b-row v-else class="row">
     <b-col v-if="item.routestops && item.routestops.length > 0" :lg="cols">
     <card> 
          <p-button @click="onSaveRoutestops()" outline class="hover-text min float-right"><em class="fa fa-check"></em><span>{{ $t('button.save') }}</span></p-button>             
          <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

          <div id="routestopsDiv">
        
          <b-table 
            striped 
            hover 
            :items="form.routestops" 
            :responsive="false"
            :small="true"
            :sort-by.sync="sortBy"
            :fields="fields"
            @row-clicked="onRowSelected">      
        
            <template #thead-top="data">
                <b-tr>
                    <b-th colspan="1"><span class="sr-only"></span></b-th>
                    <b-th>{{data.fields[1].label}}</b-th>
                    <b-th>{{data.fields[2].label}}</b-th>
                    <b-th>{{data.fields[3].label}}</b-th>
                    <b-th colspan="2">{{data.fields[5].label}}</b-th>
                    <b-th>{{data.fields[6].label}}</b-th>
                </b-tr>
            </template>
        
            <template v-slot:cell(ajoaika)="{ item, field: { key } }">
                <b-form-group v-if="item.jarjestys > 1">
                    <div class="w-50">
                        <input type="text" class="form-control" v-model="item[key]" placeholder="min">
                    </div>
                </b-form-group>
            </template>
            <template v-slot:cell(firstStopPassingTime)="{ item, field: { key } }">
                <b-form-group v-if="item.jarjestys == 1">
                    <input type="time" v-model="item[key]" locale="fi">              
                </b-form-group>
            </template>
            <template v-slot:cell(order)="data">
                <p class="mb-0">
                    <b-icon icon="dash-square-fill" variant="danger" @click="remove(data.value)" 
                    font-scale="1.2" v-b-tooltip.hover :title="$t('routestop.delete.stop')" 
                    class="clickable"></b-icon>
                    <b-icon icon="plus-square-fill" variant="primary" @click.stop="addRoutestop(data.value)" 
                    font-scale="1.2" v-b-tooltip.hover :title="$t('button.add')" 
                    class="clickable"></b-icon>
                    <b-icon icon="plus-square-fill" variant="success" v-if='data.value == "1"' @click.stop="addFirstRoutestop(data.value)" 
                    font-scale="1.2" v-b-tooltip.hover :title="$t('routestop.add_first_stop')" 
                    class="clickable"></b-icon>
                </p>
            </template>
           </b-table>
          </div> 
        </card>
      </b-col>
      <b-col sm="8" v-if="showForm">
        <card>
            <CardHeader :title="formTitle" v-on:close="onClose"></CardHeader>

            <RoutestopEdit ref="routestopEditor" 
                         :item="selectedItem" 
                         :route="route"
                         :isFirstStop="addFirstStop" 
                          v-on:refreshRoutestops="refreshRoutestops" />
        </card>
      </b-col>
     </b-row>

     </b-container>
   <DeleteModal :modalid="'routeStopModal'" :itemid="this.stopName" @ok="onDeleteOK" />

</div>    
</template>

<script>

import timetable from '@/store/timetable/timetable'
import RoutestopEdit from '@/components/Timetable/RoutestopEdit.vue'
import CardHeader from '@/components/Misc/CardHeader'
import i18n from '@/i18n'
import moment from 'moment';

export default {
    components: { RoutestopEdit, CardHeader },
    props: {
            item: {
            required: true,
        }
    },    
    data() {
        return {
            showForm: false,
            form: {
                routestops: [],
            },            
            fields: [
                { key: "jarjestys", thClass: 'd-none'},
                { key: "tunnus" , label: this.$t('routestop.id'), sortable: true, thClass: 'd-none' },
                { key: "nimi" , label: this.$t('routestop.name'), sortable: true, thClass: 'd-none' },
                { key: "ajoaika", label: this.$t('routestop.driving_time'), thClass: 'd-none' },
                { key: "ohitusaika", thClass: 'd-none',
                  formatter: (value, key, item) => {
                     if( item.jarjestys === 1 ) {                                      
                         const timeArray = item.firstStopPassingTime ? item.firstStopPassingTime.split(":") : [];                     
                         this.firstStopPassTime = item.firstStopPassingTime ? (parseInt(timeArray[0], 10) * 60) + (parseInt(timeArray[1], 10)) : 0;
                     }
                 
                     if( this.form.routestops && item.jarjestys > 1 ) {
                         let time = item.ohitusaika ? parseInt(item.ohitusaika) : 0;

                         for( let a of this.form.routestops ) {
                             if( a.ajoaika && a.jarjestys <= item.jarjestys) {
                                 time += parseInt(a.ajoaika, 10);
                             }
                         }

                         const stopPassingTime = this.firstStopPassTime + time;
                         const hours = Math.floor(stopPassingTime / 60);
                         const minutes = stopPassingTime - hours * 60;
                         let newHours = hours >= 24 ? hours - 24 : hours
                         
                         let timeStr = newHours < 10 ? "0" + newHours : newHours
                         timeStr+= ":" + (minutes < 10 ? "0" + minutes : minutes); 

                         return (this.firstStopPassTime && item.ajoaika && time > 0) ? timeStr : "";
                     }
                } },
                { key: "firstStopPassingTime", label: this.$t('routestop.passing_time'), thClass: 'd-none' },
                { key: "tyyppiselite", label: this.$t('routestop.type'), thClass: 'd-none' },
                { key: "order" , thClass: 'd-none',
                  formatter: (value, key, item) => {
                     return item ? item.jarjestys : 0;
                } }
                ],
            sortBy:"jarjestys",
            selected: [], 
            addFirstStop: false,
            firstStopPassTime: 0,
            newStop: {
                'jarjestys': "1",
                'tunnus': null,
                'nimi': null,
                'reitti': null,
            },
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.getRoutestops(this.item);        
    },
    watch: {
        item: function(item) {
            this.ok = this.error = this.loading = false;            
            this.getRoutestops(item);  
        },
    }, 
    computed: {
        formTitle(){
            if( this.addFirstStop )
                return i18n.t('routestop.add_first_stop');
            else
                return i18n.t('item.new');
        },
        cols() {
            return this.showForm ? 8 : 12;
        },        
        route() {
            return this.form ? this.form.tunnus : "";
        },
        routeName() {
            return this.form ? this.form.nimi : "";
        },        
        stopName() {
            return this.selected ? this.selected.nimi : "";
        },        
        selectedItem() {
            return this.selected ? this.selected : [];
        },        
        formattedItems() {
            let editedRoutestops = [];

            for( let rs of this.form.routestops ) {
                if( rs.ajoaika && moment(rs.ajoaika, "m", true).isValid() ) {
                    rs.ajoaika = moment(rs.ajoaika, "m").format("HH:mm:ss");
                    editedRoutestops.push(rs);
                } 
            }            
            return editedRoutestops; 
        },               
        formatItem() {
            if( this.selected ) {
                const newItem = this.selected;
                if( newItem.firstStopPassingTime ) {
                    delete newItem.firstStopPassingTime; 
                }
                if( !newItem.ajoaika )
                    newItem.ajoaika = null;
                return newItem; 
            } else 
               return null;               
        }                        
    },
    methods: {
        getRoutestops(item) {
            if( item && item.tunnus ) {
                this.form = item;
                this.$store.dispatch('timetable/getRouteStops' , item.tunnus )
                    .then( response => {
                        this.form.routestops = this.formatArray(response.data.routestops);
                        if( this.form.routestops.length === 0 ) {
                            this.addFirstRoutestop();
                        }                
                    }
                );
            }
        },            
        formatArray(array) {
            function formatTime (timeString) {
                const timeArray = timeString.split(":");
                return parseInt(timeArray[1], 10) ? parseInt(timeArray[1], 10) : "";
            }    
                        
            for( let stopItem of array ) {
                if( stopItem.jarjestys > 1 && stopItem.ajoaika ) {
                    stopItem.ajoaika = formatTime(stopItem.ajoaika);
                }
            }                                       
            return array;
        },        
        refreshRoutestops(routeId) {
            if( routeId ) {                
                setTimeout(() => {
                    this.$store.dispatch('timetable/getRouteStops' , routeId ).then( response => {
                        this.form.routestops = this.formatArray(response.data.routestops);
                        this.addFirstStop = false;
                        this.$emit('updateItem', this.form);
                        this.showForm = false;
                    }
                );
                }, 1000);
            }
        },    
        onClose(){
            this.showForm = false;
        },            
        addRoutestop: function(stopOrder) {
            this.selected = this.form.routestops[stopOrder - 1];
            this.showForm = true;
            this.addFirstStop = false;                                        
        },
        addFirstRoutestop: function() {
            this.selected = JSON.parse(JSON.stringify(this.newStop));
            this.showForm = true;
            this.addFirstStop = true;
        },
        cancelRemove(item){
            this.selected = item;
        },
        remove(stopOrder){
            this.selected = this.form.routestops[stopOrder - 1];
            this.$bvModal.show('routeStopModal')
        },
        onDeleteOK: function() {
            this.$travellerRemove();
            this.$store.dispatch('timetable/deleteRoutestop' , this.formatItem, this.item.tunnus).then( () => {
                this.$travellerRemoved();
                this.$store.dispatch('timetable/getRouteStops' , this.item.tunnus )
                    .then( response => {
                        this.form.routestops = this.formatArray(response.data.routestops);                
                        if( this.form.routestops.length === 0 ) {
                            this.addFirstRoutestop();
                        } else                 
                            this.selected = {};
                        this.$emit('updateItem', this.form);
                })
            });
        }, 
        onSaveRoutestops() {
            if( event ) 
                event.preventDefault();   

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('timetable/updateRoutestops' , this.formattedItems, this.route).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    setTimeout(() => { this.refreshRoutestops(this.route) }, 1000);
                })
            }, 1000);
        },
        onRowSelected: function() {
            this.showForm = false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#routestopsDiv {
  height: 40em;
  overflow: auto;
}
